import { create } from 'zustand';
import { io } from 'socket.io-client';

const useSocketStore = create((set, get) => ({
  socket: null,
  connectSocket: (userId) => {
    if (!get().socket) {
      // Connect to the chat API endpoint base URL
      const chatApi = process.env.REACT_APP_CHAT_API_URL || 'http://localhost:5173/api';
      const socketUrl = chatApi.replace(/\/api\/?$/, ''); // Remove /api to get the root URL for socket.io
      const socket = io(socketUrl, {
        query: { userId }
      });
      socket.on('connect', () => {
        socket.emit('register', userId);
      });
      set({ socket });
    }
  },
  disconnectSocket: () => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      set({ socket: null });
    }
  }
}));

export default useSocketStore;
